"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var R = _interopRequireWildcard(require("ramda"));

var isNumber = R.is(Number);
var _default = isNumber;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/textkit/utils/isNumber.js
// module id = 429
// module chunks = 2